import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as analyticsAPI from 'api/Analytics';
// import * as feedbackAPI from 'api/FeedBack';
import { isEmpty } from 'utils/redux';

const initialState = {
  data: null,
  totalRecord: null,
  rangeDate: null,
  CardData: null,
  features_data: null,
  lowheader: null,
  highheader: null,
  highcomponent: null,
  lowcomponent: null,
  ChartData: null,
  HighBasicCardComponent: null,
  LowBasiccardComponent: null,
  AnalyticsFeedBackData: null,
  TabName: 'All',
  TableData: null,
  userData: null,
  ui: {
    loading: false,
    msg: ''
  },
  status: '',
  pagination: {
    pageSize: 10,
    currentPage: 1,
    totalRecords: null,
    index: 1
  },
  salutationdata: null,
  SelectedSubCategoryData: null,
  SelectedBucketName: null,
  SelectedInterval: 'week',
  SelectedComponentData: null,
  panelshow: true
};
const getAnalyticState = (state) => state.reporting;

const getAnalyticsData = createAsyncThunk('analytics/getAnalytics', async ({ filterResult: analyticsData, signal }) => {
  const res = await analyticsAPI.allFilter(analyticsData, signal);
  return res.data?.data;
});
const getAnalyticsCardData = createAsyncThunk('analytics/getAnalyticsCardData', async ({ filterResult, signal }) => {
  const res = await analyticsAPI.getCardDataData(filterResult, signal);
  return res.data?.data;
});
const getTableData = createAsyncThunk('analytics/getTableData', async (params) => {
  // console.log(params, 'filterResult');
  const res = await analyticsAPI.getTableData(params);
  return res.data?.data;
});
const getChartData = createAsyncThunk('analytics/getChartData', async (params) => {
  // console.log(params, 'filterResult');
  const res = await analyticsAPI.getChartData(params);
  return res.data?.data;
});

const addAnalyticsFeedBackData = createAsyncThunk('analytics/addAnalyticsFeedBackData', async (params, { rejectWithValue }) => {
  try {
    const res = await analyticsAPI.addAnalyticsFeedBackData(params);
    return res.data?.data;
  } catch (error) {
    rejectWithValue(error);
  }
});

const getAllUsersData = createAsyncThunk('analytics/getAllUsersData', async (params, { rejectWithValue }) => {
  try {
    const res = await analyticsAPI.getAllUsersData(params);
    return res.data?.data;
  } catch (error) {
    rejectWithValue(error);
  }
});

const reportingSlice = createSlice({
  name: 'analytics',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    clearDownloadReport: (state) => {
      state.downloadreport = null;
    },
    SelectedTabName: (state, action) => {
      state.TabName = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
    },
    setPaginationData: (state, action) => {
      state.pagination = {
        pageSize: action.payload.pageSize,
        index: action.payload.index
      };
    },
    saluationAllData: (state, action) => {
      state.salutationdata = action.payload;
    },
    selectSubCategory: (state, action) => {
      state.SelectedSubCategoryData = action.payload;
    },
    setSelectedBucketName: (state, action) => {
      state.SelectedBucketName = action.payload;
    },
    setSelectedInterval: (state, action) => {
      state.SelectedInterval = action.payload;
    },
    setSelectedComponentData: (state, action) => {
      state.SelectedComponentData = action.payload;
    },
    removeChartData: (state) => {
      state.ChartData = [];
      state.TableData = [];
    },
    setPanelShow: (state, action) => {
      state.panelshow = action.payload;
    },
    setTabsdata: (state, action) => {
      state.tabs = action.payload;
    }
  },

  extraReducers: {
    [getAnalyticsCardData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getAnalyticsCardData.fulfilled]: (state, action) => {
      // console.log('features_data', action.payload);
      state.status = 'idle';
      state.ui.loading = false;
      state.CardData = action.payload;
      state.features_data = action.payload?.header_components;
      state.tabs = action.payload.sop_components;
      state.lowheader = action.payload.header_components_min_percentage;
      state.highheader = action.payload.header_components_max_percentage;
      state.highcomponent = action.payload.header_components_max_percentage;
      state.lowcomponent = action.payload.header_components_min_percentage;
      state.HighBasicCardComponent = action.payload?.sop_components_max_percentage;
      state.LowBasiccardComponent = action.payload?.sop_components_min_percentage;
      // if (isEmpty(action.payload)) {
      //   state.data = null;
      // } else {
      //   state.data = action.payload;
      // }
    },

    [getAnalyticsCardData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getAnalyticsData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getAnalyticsData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      if (isEmpty(action.payload)) {
        state.data = null;
      } else {
        state.data = action.payload;
      }
    },

    [getAnalyticsData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTableData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getTableData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      if (isEmpty(action.payload)) {
        state.TableData = null;
      } else {
        state.TableData = action.payload;
      }
      state.pagination.totalRecords = action.payload.total_records;
    },

    [getTableData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [addAnalyticsFeedBackData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [addAnalyticsFeedBackData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.AnalyticsFeedBackData = action.payload;
    },
    [addAnalyticsFeedBackData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getChartData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getChartData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.ChartData = action.payload;
    },
    [getChartData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getAllUsersData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getAllUsersData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.userData = action.payload;
    },
    [getAllUsersData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }

    // getDownloadReport
  }
});

const {
  resetState,
  clearDownloadReport,
  SelectedTabName,
  setCurrentPage,
  setPageSize,
  setPaginationData,
  saluationAllData,
  selectSubCategory,
  setSelectedBucketName,
  setSelectedInterval,
  setSelectedComponentData,
  removeChartData,
  setPanelShow,
  setTabsdata
} = reportingSlice.actions;

export default reportingSlice.reducer;

export {
  setCurrentPage,
  saluationAllData,
  setPageSize,
  setPaginationData,
  getAnalyticsData,
  getAnalyticState,
  setPanelShow,
  resetState,
  SelectedTabName,
  clearDownloadReport,
  getAnalyticsCardData,
  getTableData,
  getChartData,
  selectSubCategory,
  setSelectedBucketName,
  setSelectedInterval,
  setSelectedComponentData,
  removeChartData,
  setTabsdata,
  getAllUsersData
};
